'use strict';

function MoneyUpDashboardHomeCreditScore() {
  var _this = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyUpDashboardHomeBase];

  this.presenter = null;
  this.analytics = null;
  this.onComplete = function () {};

  this._showCreditScore = null;
  this._connectionIssueConfig = null;
  this._classNames = {
    missingScore: MoneyUpProductCell.classNames.active
  };

  this.init = function () {
    this._connectionIssueConfig = this._getConnectionIssueConfig();
  };

  this.initAllReady = function () {
    this.initPage(); // call initPage manually as this cell does not need to extend any controllers
  };

  this.initPage = function () {
    // check for current month's credit score
    this._showCreditScore = this._currentMonthScoreExists();

    var cellSettings = {
      product: 'MogoMember',
      classNameExtensions: this._classNames,
      contentExtensions: this._content
    };

    this._createProductCell(cellSettings);
    this.onComplete(); // tell page component is loaded
  };

  this._setState = function () {
    _this._productCell = _this._getProductCell();
    var productState = 'loading';
    var analyticsState = 'Loading';

    if (_this.presenter.getModelProperty('account.monthly_credit_check_opt_in')) {
      if (_this._showCreditScore) {
        productState = 'active'; // A.1.1.4.2
        analyticsState = 'Active';
      } else {
        productState = 'missingScore'; // A.1.1.4.3
        analyticsState = 'Missing Score';
      }

      // sets css vars for dial rotation
      _this._setCreditScoreDial();
    } else {
      productState = 'inactive'; // A.1.1.4.1
      analyticsState = 'Inactive';
    }

    _this._productCell.setState(productState, analyticsState);
    // no scenarios for when an alert occurs
    _this._setAlertState(analyticsState);
  };

  this._setAlertState = function () {
    _this._productCell.showAlert(false);
  };

  this._setCreditScoreDial = function () {
    var creditScoreDial = _this.node.querySelector('.js--product-dial');
    var score = _this.presenter.getModelProperty('account.credit_score');
    var creditScoreMin = 300;
    var creditScoreMax = 900;
    var totalDegrees = 300;
    var negativeDegrees = 60;

    // if credit score is within valid limits (300-900)
    if (score >= creditScoreMin && score <= creditScoreMax) {
      // calculate position of dial indicator
      var creditScoreDeg = (score - creditScoreMin) / (creditScoreMax - creditScoreMin) * totalDegrees - negativeDegrees;
      creditScoreDial.style.setProperty('--creditScore', creditScoreDeg + 'deg');
    }

    creditScoreDial.classList.add('animate');

    if (!_this._showCreditScore) {
      creditScoreDial.classList.add('missing-score');
    }
  };

  // dynamic content construction
  this._getActiveContentString = function () {
    var date = moment(new Date()).format('MMM YYYY');
    var scoreText = '<div class="dashboard-product__content__data">...</div>'; // A.1.1.4.3

    if (_this._showCreditScore) {
      // A.1.1.4.2
      var score = _this.presenter.getModelProperty('account.credit_score');
      var trend = _this.presenter.getModelProperty('account.credit_score_trend'); // 'positive' or 'negative'
      var trendHtml = _this._productCell._getTrendArrowHtml(trend === 'positive' ? 'up' : trend === 'negative' ? 'down' : '');
      scoreText = '\n      <div class="dashboard-product__content__data-container">\n        <div class="dashboard-product__content__data">\n          ' + score + '\n        </div>\n        ' + trendHtml + '\n      </div>';
    }

    return date + '<br>' + scoreText;
  };

  // check for current month's credit score
  this._currentMonthScoreExists = function () {
    var latestCreditScoreDate = moment(_this.presenter.getModelProperty('account.credit_check_completed_at'));
    return moment(latestCreditScoreDate).isSame(moment(), 'month') && !!_this.presenter.getModelProperty('account.credit_score');
  };

  // define after any methods that are referenced in definition
  this._content = {
    inactive: 'Monitor your credit score for free with our partner',
    active: this._getActiveContentString,
    missingScore: this._getActiveContentString
  };

  this.destroy = function () {
    this.node.querySelector('.js--product-dial').classList.remove('animate');
  };
}